import {
  // We can't quite move to redux/toolkit yet, as some of our reducers modify state when they shouldn't
  // We also have uses of immutableJS, which isn't supported properly
  legacy_createStore as createStore,
  applyMiddleware,
  combineReducers,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';
import { spawn } from 'redux-saga/effects';

import crudReducer from 'modules/crud/reducers';
import widgetReducer from 'lib/widget/reducers';
import { widgetSaga } from 'lib/widget/sagas';
import listbrowserReducer from 'lib/listbrowser/reducers';
import contractsReducer from 'modules/contracts/reducers';
import searchReducer from 'lib/search/reducers';
import { progressReducer } from 'lib/popsss/progress/reducers';
import faqsReducer from 'views/shared_portals/faq/reducers';

export const sagaMiddleware = createSagaMiddleware();

export function dummyReducer() {
  return null;
}

function createRootReducer(entryPoint, entryPointReducer) {
  const reducers = {
    progress: progressReducer,
    contracts: contractsReducer,
    crud: crudReducer,
    widget: widgetReducer,
    listbrowser: listbrowserReducer,
    production_listbrowser: listbrowserReducer,
    search_beta: searchReducer,
    faqs: faqsReducer,
  };

  if (entryPointReducer) {
    reducers[entryPoint] = entryPointReducer;
  }

  return combineReducers(reducers);
}

function createRootSaga() {
  function* rootSaga() {
    yield spawn(widgetSaga);
  }

  return rootSaga;
}

/**
 * Create Redux entry point store from root reducer
 * @param {String} entry point name, will be used as top-level key for the supplied root reducer
 * @param {Object} root reducer for entry point
 * @param {Object} options:
 *                 persist {Array}  list of top-level reducers that should be persisted
 *                 useWidget {bool} enable widget module reducers
 *                 useCRUD {bool}   enable CRUD module reducers
 * @return {Object} Redux store
 */
export function configureStore(entryPoint, entryPointReducer, options = {}) {
  const rootReducer = createRootReducer(entryPoint, entryPointReducer);
  const rootSaga = createRootSaga();
  const middlewares = [thunkMiddleware, sagaMiddleware];
  let engine;

  if (window.store) {
    throw new Error(
      'Store already configured, there should be only one per page.',
    );
  }

  const store = createStore(
    rootReducer,
    undefined,
    composeWithDevTools(applyMiddleware(...middlewares)),
  );
  sagaMiddleware.run(rootSaga);

  window.store = store;

  return store;
}
